import React, { useState } from "react";
import "../../Assets/styles/Gift.css";

const GiftSection = () => {
  const IBAN = "PT50 0010 0000 6390 7580 0012 7";

  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(IBAN.replace(/\s/g, ""));
      setCopied(true);
      setTimeout(() => setCopied(false), 1400);
    } catch (e) {
      // If clipboard not allowed, do nothing (still shows IBAN)
    }
  };

  return (
    <section className="gift-section" id="gifts">
      <div className="gift-inner">
        <div className="gift-header">
          <p className="gift-subtitle">
          A vossa presença é, sem dúvida, o mais importante para nós, para vivermos o nosso casamento rodeados das pessoas de quem mais gostamos.
          <br/>
          Se, ainda assim, quiserem contribuir de alguma forma, deixamos aqui uma forma de o tornarem possível:
          </p>
        </div>

        <div className="gift-card">
          <div className="gift-card-row">
            <div className="gift-label">IBAN</div>
            <div className="gift-iban-wrap">
              <div className="gift-iban" aria-label="IBAN">
                {IBAN}
              </div>

              <button type="button" className="gift-copy" onClick={handleCopy}>
                {copied ? "Copiado" : "Copiar"}
              </button>
            </div>
          </div>
        </div>
        <br></br>
        <p className="gift-subtitle gift-footer-text">
          Mais do que tudo, agradecemos por estarem connosco — isso é o que torna este dia inesquecível!
        </p>
      </div>
    </section>
  );
};

export default GiftSection;